// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UDvSXdtJwGkVaGG61NrKcA\\=\\={animation:_5m9RgOP06SJrkKrN3axviQ\\=\\= 5s linear infinite}.UDvSXdtJwGkVaGG61NrKcA\\=\\=.h8IZ9p-rwMo2PLWYYBoZjw\\=\\={animation:Ig9FGQz43Ji448rl0xR8MQ\\=\\= 2s linear infinite;width:.6rem}@keyframes _5m9RgOP06SJrkKrN3axviQ\\=\\={0%{left:0;right:0;width:0}70%{left:0;right:100%;width:0}75%{left:0;right:75%;width:3rem}95%{left:75%;right:0;width:3rem}to{left:100%;right:0;width:0}}@keyframes Ig9FGQz43Ji448rl0xR8MQ\\=\\={0%{height:0;top:0}30%{height:1rem}70%{height:1rem}to{height:0;top:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animatedDot": "UDvSXdtJwGkVaGG61NrKcA==",
	"indicator": "_5m9RgOP06SJrkKrN3axviQ==",
	"vertical": "h8IZ9p-rwMo2PLWYYBoZjw==",
	"indicatorvertical": "Ig9FGQz43Ji448rl0xR8MQ=="
};
module.exports = ___CSS_LOADER_EXPORT___;
